<div class="unauth-split-layout">

  <!-- ─── Left panel — persists across child route changes ─── -->
  <div class="unauth-left">
    <div class="unauth-grid-overlay"></div>
    <img src="assets/images/complydome-logo.png" alt="ComplyDome" class="unauth-brand-logo">

    <div class="unauth-left-content">
      <div class="unauth-deco-ring">
        <lottie-player
          src="assets/complydome-workflow.json"
          background="transparent"
          speed="1"
          loop
          autoplay>
        </lottie-player>
      </div>
      <h1>Perpetual Audit Readiness.</h1>
      <p>Your entire compliance workflow is silently monitored, tracked, and enforced in real time. Log in to access your command center.</p>
    </div>
  </div>

  <!-- ─── Right panel — child renders header + form; layout owns footer ─── -->
  <div class="unauth-right">
    <router-outlet></router-outlet>

    <footer class="unauth-footer">
      <div class="unauth-footer-links">
        <a href="#" (click)="openPopup('privacy'); $event.preventDefault()">Privacy</a>
        <a href="#" (click)="openPopup('service'); $event.preventDefault()">Terms</a>
        <a href="#" (click)="openPopup('accessibility'); $event.preventDefault()">Accessibility</a>
        <a href="mailto:support@complydome.com">Contact</a>
      </div>
      <div class="unauth-footer-meta">&copy; {{ currentYear }} ComplyDome LLC</div>
    </footer>
  </div>

  <app-legal-popups [popup]="popup" (close)="closePopup()"></app-legal-popups>

</div>
